import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  setWithdrawBank,
  setDefaultBank,
  setPassword,
  verifyPassword,
  confirmTransfer,
  setwithdrawAmount,
} from "../redux/slices/walletWithdrawSlice";
import { RootState } from "../redux/store";
import { useState } from "react";
import { toast } from "sonner"; // Import toast
import { Banks } from "constant/wallet-constant";

const useWalletWithdraw = () => {
  const dispatch = useDispatch();
  const banks = Banks;
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [isPassword, setIsPassword] = useState(false);

  // Redux state
  const {
    withdrawBank,
    defaultBank,
    password,
    transferStatus,
    withdrawAmount,
  } = useSelector((state: RootState) => state.walletWithdraw);

  const handleBankChange = (value: any) => {
    dispatch(setWithdrawBank(value));
  };

  const handlePassswordChange = (value: string) => {
    dispatch(setPassword(value));
  };

  const handleWithdrawAmountChange = (value: number) => {
    dispatch(setwithdrawAmount(value));
  };

  const toggleSaveAsDefaultBank = () => {
    dispatch(setDefaultBank(defaultBank));
  };
  const handleModalConfirm = () => {
    if (!withdrawAmount || !withdrawBank) {
      toast.warning("Please provide Bank  and amount!");
      return;
    }
    setShowModal(false);

    handleConfirmTransfer();
  };

  const toggleConfirmModal = () => {
    setShowModal(!showModal);
  };

  const resetTransferData = () => {
    dispatch(setWithdrawBank(1));
    dispatch(setDefaultBank(1));
    dispatch(setPassword(""));
    dispatch(verifyPassword("kim"));
    dispatch(confirmTransfer(""));
  };

  const handleConfirmTransfer = () => {
    console.log(defaultBank, "-", withdrawAmount, "-", withdrawBank);
    if (!withdrawAmount || !withdrawBank) {
      toast.error("Please provide Bank and amount!");
      return;
    }

    dispatch(
      confirmTransfer({
        withdrawBank,
        defaultBank,
        password,
        transferStatus,
        withdrawAmount,
      })
    );
    toast.success("Transfer details confirmed!");
    navigate("provide-password");
  };

  // Action: Verify Password
  const handlePasswordSubmit = () => {
    if (!password) {
      toast.error("Password cannot be empty!");
      return;
    }

    dispatch(verifyPassword(password));
    if (transferStatus === "password-verified") {
      toast.success("Password verified!");
      navigate("/wallet");
    } else {
      toast.error("Password mismatch! Please try again.");
    }
  };

  return {
    banks,
    withdrawBank,
    defaultBank,
    password,
    transferStatus,
    withdrawAmount,
    showModal,
    isPassword,
    setIsPassword,
    navigate,
    handleBankChange,
    handlePassswordChange,
    toggleSaveAsDefaultBank,
    handleModalConfirm,
    toggleConfirmModal,
    resetTransferData,
    handleWithdrawAmountChange,
    handlePasswordSubmit,
  };
};
export default useWalletWithdraw;
